// extracted by mini-css-extract-plugin
module.exports = {"xs":"Stack_xs__jOAYI","s":"Stack_s__13-Jm","m":"Stack_m__34Zpq","l":"Stack_l__2YiRr"};